<style scoped lang="css">
    #login {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
        display: "";
        background-color: white;
    }
</style>
<template>
    <v-app id="login">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm6 md6 lg6 xl6 style="text-align: center;">
                        <v-flex xs12 sm8 md8 lg6 xl6 style="text-align: center;margin:auto;padding: 20px;min-width: 350px">
                            <img :src="logoSrc" :alt="$t('lang.header.title')" style="max-width: 100%; height: auto" />
<!--                            <img src="/img/logo.png" :alt="$t('lang.header.title')" style="max-width: 100%;height: auto"/>-->
                            <div>
                                <div class="layout column align-center">
                                    <!--h1 class="flex my-4">{{ $t('lang.common.login') }}</h1-->
                                    <div class="layout column align-center">
                                        <div class="flex my-4 primaryColor" style="font-size: 20px; font-weight: bold">
                                            {{firstTitle}}<br/>
                                        </div>
                                        <!--div style="margin-bottom: 10px;font-size: 20px"> {{welcome}} {{welcomeRole}}
                                            <label class="primaryColor">{{welcomeName}}</label></div-->
                                    </div>
                                </div>
                                <!--div>
                                  <a class="btn facebook mt12  mb12" @click="facebookLogin">
                                    <i class="fa fa-facebook"></i> Facebook
                                  </a>
                                  <a class="btn google mt12 mb12" @click="googleLogin">
                                    <i class="fa fa-google"></i> Google
                                  </a>
                                </div-->
                                <v-form lazy-validation key="loginForm" @keyup.enter.native.prevent="handleSubmit"
                                        ref="loginForm" @submit.prevent>
                                    <v-text-field v-validate="'required'"
                                                  name="login"
                                                  key="login"
                                                  :label="$t('lang.user.username')"
                                                  type="text" v-model="username"
                                                  @click:append="changeAccount"
                                                  autofocus
                                                  ref="username"
                                                  :data-vv-as="$t('lang.user.username')"
                                                  :error-messages="errors.first('login')">
                                        <template slot="append">
                                            <v-icon v-if="step==0">person</v-icon>
                                            <a class="primaryColor" v-else @click="changeAccount">Thay đổi</a>
                                        </template>
                                    </v-text-field>
                                    <v-text-field
                                                  v-validate="'required'"
                                                  append-icon="lock"
                                                  name="password"
                                                  key="password"
                                                  :label="$t('lang.user.password')"
                                                  id="password"
                                                  type="password"
                                                  v-model="password"
                                                  :data-vv-as="$t('lang.user.password')"
                                                  :error-messages="errors.first('password')"/>
                                </v-form>
                                <div style="text-align: right">
                                    <a @click="forgetPassword" style="text-align: right"
                                       class="primaryColor">Quên mật khẩu</a>
                                </div>
                            </div>
                            <v-card-actions>
                                <lang-switcher></lang-switcher>
                                <div style="text-align: right;width: 100%">
                                    <v-btn class="yoprimary" dark @click="handleSubmit" v-if="count<5">
                                        {{$t('lang.user.login')}}
                                    </v-btn>
                                    <!--br/>
                                    <v-btn class="primaryColor" flat @click="cancel">{{ $t('lang.common.cancel') }}
                                    </v-btn-->
                                </div>
                            </v-card-actions>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6 xl6 style="text-align: left" class="hideInMobile">
                        <img src="/img/warehouse2.png">
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import LangSwitcher from "../components/header/LangSwitcher";
    import {message} from '../services';
    import axios from "axios";
    import {Validator} from "vee-validate";

    export default {
        components: {
            LangSwitcher
        },
        data() {
            return {
                user: null,
                username: '',
                password: '',
                step: 0,
                count: 0,
                submitted: false
            }
        },

        computed: {
            logoSrc() {
              const domain = window.location.hostname
              if (domain.includes("lms-edusmart.")) {
                return "/img/logo-edusmart1.png"
              }
              if (domain.includes("localhost")) {
                return "/img/logo-edusmart1.png"
              }
              // default
              return "/img/logo.png"
            },
            firstTitle: function () {
                return "Chào mừng bạn đến với hệ thống phần mềm quản lý tiến độ học tập";
            },

            secondTitle: function () {
                if (this.step == 0) {
                    return "";
                } else {
                    return "Để học tập hiệu quả hơn cùng Yoclass!";
                }
            },

            suffix: function () {
                if (this.step == 0) {
                    return "";
                } else {
                    return "Thay đổi";
                }
            },

            appendIcon: function () {
                if (this.step == 0) {
                    return "person";
                } else {
                    return "edit";
                }
            },

            welcome: function () {
                if (this.user == null) {
                    return ""
                } else {
                    return "Rất vui được gặp lại ";
                }
            },

            welcomeRole: function () {
                if (this.user == null) {
                    return ""
                } else {
                    if (this.user.role == 1 || this.user.role == 4) {
                        if (this.user.gender || this.user.gender == "true") {
                            return "thầy ";
                        } else {
                            return "cô";
                        }
                    } else {
                        return "bạn";
                    }
                }
            },

            welcomeName: function () {
                if (this.user == null) {
                    return ""
                } else {
                    return this.user.fullName
                }
            }
        },

        beforeCreate() {
        },

        beforeRouteUpdate() {
            console.log("route updated");
        },

        created() {
            console.log("created");
            this.count = sessionStorage.wrongPasswordCount;
            if (this.count == undefined || this.count == null) {
                this.count = 0;
            }
            if (this.$store.state.auth.loggedIn) {
                this.$router.push('/HomePage');
            } else {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                axios.defaults.headers.common["Authorization"] = null;
                delete axios.defaults.headers.common["Authorization"];

                this.step = 0;
                window.fbAsyncInit = function () {
                    FB.init({
                        appId: '998333920543921',
                        cookie: true,
                        xfbml: true,
                        version: 'v5.0'
                    });

                    //FB.AppEvents.logPageView();

                };

                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {
                        return;
                    }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));

            }
            // reset login status
            //this.$store.dispatch('auth/logout');
        },

        mounted() {
            Validator.extend("checkPhoneOrEmail", {
                    validate(value) {
                        try {
                            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                                return true;
                            } else {
                                let phoneno = /^\d{5,11}$/;
                                if (value.match(phoneno)) {
                                    return true;
                                }
                            }
                            return false;
                        } catch (e) {
                            return false;
                        }
                    },

                    getMessage: field => {
                        return field + " không đúng định dạng";
                    },
                }
            );
            this.checkParam();
        },

        render() {
            console.log("rendered");
        },

        watch: {
            '$route'(to, from) {
                //console.log(to);
                //console.log(from);
                this.$refs.username.focus();
            }
        },

        methods: {
            handleSubmit() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error("Bạn chưa nhập thông tin số điện thoại,email hoặc thông tin nhập không chính xác");
                        return;
                    }
                    this.login();
                });
            },

            changeAccount: function () {
                if (this.step == 0) {
                    return;
                }
                this.cancel();
            },

            cancel() {
                this.username = "";
                if (this.step == 1) {
                    this.step = 0;
                    this.$refs.username.focus();
                    this.user = null;
                    this.$validator.reset();
                } else {
                    this.$router.go(-1);
                }
            },

            checkParam() {
                let userName = this.$route.params.userName;
                if (userName != undefined && userName != null) {
                    this.username = userName;
                }
                let password = this.$route.params.password;
                if (password != undefined && password != null) {
                    this.password = password;
                }
                console.log(this.username);
                console.log(this.password);
                if (this.username != undefined && this.username != null && this.username != ""
                    && this.password != undefined && this.password != null && this.password != "") {
                    this.login();
                }
            },

            login() {
                if (this.count == 5) {
                    message.error("Tài khoản tạm thời bị khóa do bạn nhập sai mật khẩu 5 lần");
                    return;
                }
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    this.submitted = true;
                    let username = this.username;
                    let password = this.password;
                    if (this.user != undefined && this.user != null) {
                        if (username != this.user.userName) {
                            username = this.user.userName;
                        }
                    }
                    const {dispatch} = this.$store;
                    if (username && password) {
                        const domain = window.location.hostname;
                        const product = domain.includes("lms-edusmart.")
                            ? "EDUSMART"
                            : "BABILALA";
                        dispatch('auth/login', {cred: {username, password, product}, vm: this});
                    }
                });
            },

            updateCount: function () {

                console.log("count");
                console.log(this.count);
                if (this.count < 5) {
                    this.count++;
                }
                sessionStorage.wrongPasswordCount = this.count;
            },

            forgetPassword: function () {
                alert("Liên hệ với admin trường hiện tại để lấy lại mật khẩu")
                //this.$router.push("/forgotPassword/" + this.username);
            },

            getFacebookInfo: function (author, vue) {
                let access_token = author.authResponse.access_token;
                let type = "facebook";
                dispatch('auth/login', {cred: {access_token, type}, vm: vue});
            },

            facebookLogin: function () {
                let v = this;
                const {dispatch} = this.$store;
                FB.getLoginStatus(function (r) {
                    if (r.status === 'connected') {
                        //v.getFacebookInfo(r, v);
                        console.log(r);
                        let access_token = r.authResponse.accessToken;
                        let type = "facebook";
                        dispatch('auth/login', {cred: {access_token, type}, vm: v});
                    } else {
                        FB.login(function (author) {
                            //v.getFacebookInfo(author, v);
                            console.log(author);
                            let access_token = author.authResponse.accessToken;
                            let type = "facebook";
                            dispatch('auth/login', {cred: {access_token, type}, vm: v});
                        }, {scope: 'email'}); // which data to access from user profile
                    }
                });
            },

            googleLogin: function () {
                var auth2;
                var v = this;
                const {dispatch} = this.$store;
                gapi.load('auth2', function () {
                    gapi.auth2.authorize({
                        client_id: '98948171933-iutm4oq2i464cvhl5s24ecc6luvmvbbi.apps.googleusercontent.com',
                        scope: 'email profile openid',
                        response_type: 'id_token permission code id'
                    }, function (response) {
                        if (response.error) {
                            // An error happened!
                            return;
                        }
                        let access_token = response.access_token;
                        let type = "google";
                        dispatch('auth/login', {cred: {access_token, type}, vm: v});
                    });

                });
            },

        }
    };
</script>

